// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__SPjgM","modal":"Modal_modal__XTbdc","closeButton":"Modal_closeButton__KVSwx","title":"Modal_title__g6oAZ","content":"Modal_content__Kq9-p"};